/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountInputDto { 
    id?: number;
    name: string;
    accountCode?: string | null;
    type: string;
    isDefault?: boolean;
    openingBalance?: number | null;
}

